import {BookingStepBase} from "./booking-step.base";
import {IManageMyBookingRoutes} from "../../../navigation/routes/manage-my-booking/manage-my-booking.routes.interface";

export abstract class ManageMyBookingStepBase extends BookingStepBase {
    protected get routes(): IManageMyBookingRoutes {
        return this.services.navigator.routes.manageMyBooking;
    }
}
